<template>
  <div class="vote-count">
    <span class="vote-count__percent" data-test-id="vote-count-percent">
      {{ percentageString }}
    </span>
    <div class="vote-count__details">
      <p class="vote-count__text" data-test-id="vote-count-text">
        {{ answer | decodeHtml }}
      </p>
      <div class="vote-count__bar">
        <div class="vote-count__bar-fill" :style="`width: ${calcPercent}%;`" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoteCount',
  props: {
    answer: {
      type: String,
      required: true,
    },
    votes: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  computed: {
    calcPercent() {
      return this.total > 0 ? Math.floor((this.votes * 100) / this.total) : 0;
    },
    percentageString() {
      return `${this.calcPercent}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_vote-count';
</style>

<docs>
Vote Count

</docs>
